module.exports = __webpack_public_path__ + "static/media/PDF_92.3b9259b2.pdf";